const getUserRoleFromJWT = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const decodedPayload = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
    );

    // Azure AD tokens use the MS-specific claim; backend-issued tokens (ExternalUser) use "role"
    const roleFromToken =
      decodedPayload[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ] ||
      decodedPayload["role"] ||
      null;

    // Fall back to the role stored in localStorage for external users whose
    // backend-issued JWT may not embed a role claim.
    return roleFromToken !== null && roleFromToken !== undefined
      ? roleFromToken
      : localStorage.getItem("userRole") || null;
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return localStorage.getItem("userRole") || null;
  }
};

export default getUserRoleFromJWT;
